<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="1200px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
            <span class="px-3">{{ $t("View Sale Return's information") }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <!-- %%%%%%%%%%%%%%%%% Print Section Title %%%%%%%%%%%%%%%%% -->
          <table class="section-title-table only-for-print">
            <tr>
              <th class="section-title-content">{{ $t('Sales Returns') }}</th>
            </tr>
          </table>

          <v-layout row wrap class="invoice-content">
            <v-flex xs12 sm12 :class="{ 'px-4': $vuetify.breakpoint.smAndUp }">
              <v-layout row wrap>
                <table class="info-table" style="width: 100%">
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Return Bill Number') }}
                      </div>
                      <strong>{{ viewInfo.return_sale_number || '-' }}</strong>
                    </td>
                    <td
                      class="td-padding-bottom not-printable"
                      v-if="viewInfo.attachment != null && viewInfo.attachment != 'undefined'"
                    >
                      <a
                        :href="`${baseUrls.images}/${viewInfo.attachment}`"
                        target="_blank"
                        style="padding-top: 10px; text-decoration: none"
                      >
                        <v-icon color="blue" size="20" :right="$vuetify.rtl" :left="!$vuetify.rtl"
                          >fa-external-link-alt</v-icon
                        >
                        <span style="color: #2196f3">{{ $t('Attachment') }}</span>
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Customer Name') }}
                      </div>
                      <strong>{{ viewInfo.customer_name || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Bill Number') }}
                      </div>
                      <strong>{{ viewInfo.bill_auto_number || '-' }}</strong>
                    </td>
                    <td class="td-padding-bottom">
                      <div class="caption no-select">
                        {{ $t('Return Date') }}
                      </div>
                      <strong v-if="viewInfo.return_date">
                        {{ viewInfo.return_date }}
                      </strong>
                      <strong v-else>-</strong>
                    </td>
                  </tr>
                </table>

                <table class="printed-table" cellspacing="0">
                  <thead>
                    <tr class="only-for-print">
                      <td>
                        <div class="header-space">&nbsp;</div>
                      </td>
                    </tr>
                    <tr>
                      <th xs1 class="pa-2 view-table-header">#</th>
                      <th class="view-table-header" xs5 pa-2>
                        {{ $t('Product') }}
                      </th>
                      <th class="view-table-header" xs5 pa-2 v-if="hasCollection">
                        {{ $t('Collection') }}
                      </th>
                      <th class="view-table-header" xs2 pa-2>
                        {{ $t('Quantity') }}
                      </th>
                      <th class="view-table-header" xs2 pa-2>
                        {{ `${$t('Price')} (${systemCurrency})` }}
                      </th>
                      <th class="view-table-header" xs2 pa-2>
                        {{ `${$t('Total')} (${systemCurrency})` }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in rowNumbers" :key="index">
                      <td class="view-table-row">
                        <p class="view-table-content">{{ index + 1 }}</p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.product_name[index] }}
                        </p>
                      </td>
                      <td class="view-table-row" v-if="hasCollection">
                        <p class="view-table-content">
                          {{ viewInfo.collection_name[index] }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.return_quantity[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.return_price[index] | currency }}
                        </p>
                      </td>
                      <td class="view-table-row">
                        <p class="view-table-content">
                          {{ viewInfo.total[index] | currency }}
                        </p>
                      </td>
                    </tr>
                    <tr class="last-table-row-for-currency">
                      <td class="last-table-row" :colspan="hasCollection ? 5 : 4">
                        <p class="view-table-content">
                          {{ `${$t('Total Return Amount')} (${systemCurrency})` }}
                        </p>
                      </td>
                      <td class="last-table-row2">
                        <p class="view-table-content">
                          {{ viewInfo.return_total_amount | currency }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="only-for-print">
                      <td>
                        <div class="footer-space">&nbsp;</div>
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <invoice-footer
                  :showSignatureSection="false"
                  :accountantName="''"
                  :payerRecipientName="''"
                  :payerOrRecipient="''"
                  class="only-for-print"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">
            {{ $t('Close') }}
          </v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      viewInfo: {
        sale_return_id: 0,
        customer_name: '',
        return_date: '',
        bill_auto_number: '',
        return_sale_number: '',
        return_total_amount: '',
        product_name: [],
        collection_name: [],
        return_quantity: [],
        return_price: [],
        total: []
      },
      rowNumbers: 0
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      saleReturnInfo: 'salesReturns/getSaleReturnInfo',
      settings: 'configurations/getSystemSettings'
    }),
    hasCollection() {
      return this.settings.production_collections === 'Active'
    }
  },

  watch: {
    viewDialog: {
      immediate: false,
      handler() {
        if (this.viewDialog) {
          this.rowNumbers = this.saleReturnInfo.data_detail.length
          this.viewInfo.customer_name = this.saleReturnInfo.data.customer_name
          this.viewInfo.return_date = this.saleReturnInfo.data.return_date
          this.viewInfo.return_sale_number = this.saleReturnInfo.data.return_sale_number
          this.viewInfo.bill_auto_number = this.saleReturnInfo.data.bill_auto_number
          this.viewInfo.return_total_amount = this.saleReturnInfo.data.return_total_amount
          this.viewInfo.sale_return_id = this.saleReturnInfo.data.sale_return_id

          this.viewInfo.product_name = []
          this.viewInfo.collection_name = []
          this.viewInfo.return_quantity = []
          this.viewInfo.return_price = []
          this.viewInfo.total = []

          this.saleReturnInfo.data_detail.forEach((c, index) => {
            this.viewInfo.product_name.push(c.product_name)
            this.viewInfo.collection_name.push(c.collection_name)
            if (this.viewInfo.collection_name[index]) {
              this.viewInfo.return_quantity.push(c.return_collection_quantity)
              this.viewInfo.return_price.push(c.return_collection_price)
              this.viewInfo.total.push(c.total_collection)
            } else {
              this.viewInfo.return_quantity.push(c.return_quantity)
              this.viewInfo.return_price.push(c.return_price)
              this.viewInfo.total.push(c.total)
            }
          })
        }
      }
    }
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    printMe() {
      // helpers.doPrinting(true)
      let onlyForPrint = document.querySelectorAll('.only-for-print')
      let notPrintable = document.querySelectorAll('.not-printable')
      let invoiceContent = document.querySelector('.invoice-content')
      let theDialogContent = document.querySelector('.view-dialog-content')
      let infoTable = document.querySelector('.info-table')
      theDialogContent.classList.remove('grey')
      infoTable.classList.add('add-padding-for-info-table')
      invoiceContent.style.marginTop = '90px'
      notPrintable.forEach(element => {
        element.style.display = 'none'
      })
      onlyForPrint.forEach(element => {
        element.style.display = 'block'
      })
      document.querySelector('.printed-table').style.marginTop = '-120px'

      this.$htmlToPaper('printArea', () => {
        infoTable.classList.remove('add-padding-for-info-table')
        theDialogContent.classList.add('grey')
        invoiceContent.style.marginTop = '0px'
        onlyForPrint.forEach(element => {
          element.style.display = 'none'
        })
        notPrintable.forEach(element => {
          element.style.display = 'flex'
        })
        document.querySelector('.printed-table').style.marginTop = '0px'
      })
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
